"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
/**
 * Spell Check Panel Component
 * Dedicated panel for spell checking functionality with detailed statistics
 */
const react_1 = __importStar(require("react"));
const lucide_react_1 = require("lucide-react");
const spellCheckManager_1 = require("../services/spellCheckManager");
const SpellCheckPanel = ({ activeSource, segments, onSpellCheckComplete, className = '' }) => {
    const [isRunning, setIsRunning] = (0, react_1.useState)(false);
    const [progress, setProgress] = (0, react_1.useState)(null);
    const [showProgress, setShowProgress] = (0, react_1.useState)(false);
    const handleSpellCheck = async () => {
        if (!activeSource || segments.length === 0)
            return;
        setIsRunning(true);
        setShowProgress(true);
        setProgress({
            total: segments.length,
            processed: 0,
            current: 'Připravuji kontrolu pravopisu...',
            isRunning: true
        });
        try {
            const result = await spellCheckManager_1.spellCheckManager.batchSpellCheckProject(segments, setProgress);
            if (onSpellCheckComplete) {
                onSpellCheckComplete(result.summary, result.updatedSegments);
            }
        }
        catch (error) {
            console.error('Spell check failed:', error);
            setProgress({
                total: 1,
                processed: 1,
                current: 'Chyba při kontrole pravopisu',
                isRunning: false
            });
        }
        finally {
            setIsRunning(false);
            setTimeout(() => {
                setProgress(null);
                setShowProgress(false);
            }, 2000);
        }
    };
    const handleCancel = () => {
        spellCheckManager_1.spellCheckManager.cancelBatchSpellCheck();
        setIsRunning(false);
        setProgress(null);
        setShowProgress(false);
    };
    // Calculate spell check statistics
    const spellCheckStats = react_1.default.useMemo(() => {
        const total = segments.length;
        const withErrors = segments.filter(s => s.spellCheck?.hasErrors).length;
        const withoutErrors = total - withErrors;
        const totalErrors = segments.reduce((sum, s) => sum + (s.spellCheck?.errors?.length || 0), 0);
        return {
            total,
            withErrors,
            withoutErrors,
            totalErrors,
            errorRate: total > 0 ? Math.round((withErrors / total) * 100) : 0
        };
    }, [segments]);
    const getSourceIcon = (sourceType) => {
        switch (sourceType) {
            case 'youtube_manual':
            case 'youtube_auto':
                return (0, jsx_runtime_1.jsx)(lucide_react_1.FileText, { className: "w-4 h-4" });
            case 'whisper_transcription':
                return (0, jsx_runtime_1.jsx)(lucide_react_1.Mic, { className: "w-4 h-4" });
            default:
                return (0, jsx_runtime_1.jsx)(lucide_react_1.FileText, { className: "w-4 h-4" });
        }
    };
    const getSourceLabel = (source) => {
        switch (source.source_type) {
            case 'youtube_manual':
                return 'YouTube (manuální)';
            case 'youtube_auto':
                return 'YouTube (automatické)';
            case 'whisper_transcription':
                return 'Whisper AI';
            default:
                return source.source_name;
        }
    };
    if (!activeSource) {
        return ((0, jsx_runtime_1.jsx)("div", { className: `bg-gray-50 border border-gray-200 rounded-lg p-4 ${className}`, children: (0, jsx_runtime_1.jsxs)("div", { className: "text-center text-gray-500", children: [(0, jsx_runtime_1.jsx)(lucide_react_1.SpellCheck, { className: "w-8 h-8 mx-auto mb-2 text-gray-400" }), (0, jsx_runtime_1.jsx)("p", { className: "text-sm font-medium", children: "Kontrola pravopisu" }), (0, jsx_runtime_1.jsx)("p", { className: "text-xs text-gray-400 mt-1", children: "Vyberte zdroj titulk\u016F pro kontrolu" })] }) }));
    }
    return ((0, jsx_runtime_1.jsxs)("div", { className: `bg-white border border-gray-200 rounded-lg ${className}`, children: [(0, jsx_runtime_1.jsxs)("div", { className: "p-4 border-b border-gray-100", children: [(0, jsx_runtime_1.jsxs)("div", { className: "flex items-center space-x-2 mb-2", children: [(0, jsx_runtime_1.jsx)(lucide_react_1.SpellCheck, { className: "w-5 h-5 text-blue-600" }), (0, jsx_runtime_1.jsx)("h3", { className: "text-sm font-semibold text-gray-900", children: "Kontrola pravopisu" })] }), (0, jsx_runtime_1.jsxs)("div", { className: "flex items-center space-x-2 text-xs text-gray-600", children: [getSourceIcon(activeSource.source_type), (0, jsx_runtime_1.jsx)("span", { children: getSourceLabel(activeSource) }), (0, jsx_runtime_1.jsx)("span", { children: "\u2022" }), (0, jsx_runtime_1.jsxs)("span", { children: [segments.length, " segment\u016F"] })] })] }), (0, jsx_runtime_1.jsxs)("div", { className: "p-4 border-b border-gray-100", children: [(0, jsx_runtime_1.jsxs)("div", { className: "grid grid-cols-2 gap-3", children: [(0, jsx_runtime_1.jsxs)("div", { className: "bg-green-50 p-3 rounded-lg", children: [(0, jsx_runtime_1.jsxs)("div", { className: "flex items-center space-x-2", children: [(0, jsx_runtime_1.jsx)(lucide_react_1.CheckCircle, { className: "w-4 h-4 text-green-600" }), (0, jsx_runtime_1.jsx)("span", { className: "text-xs font-medium text-green-800", children: "Bez chyb" })] }), (0, jsx_runtime_1.jsx)("div", { className: "text-lg font-bold text-green-900 mt-1", children: spellCheckStats.withoutErrors }), (0, jsx_runtime_1.jsxs)("div", { className: "text-xs text-green-600", children: [spellCheckStats.total > 0 ? Math.round((spellCheckStats.withoutErrors / spellCheckStats.total) * 100) : 0, "% segment\u016F"] })] }), (0, jsx_runtime_1.jsxs)("div", { className: "bg-red-50 p-3 rounded-lg", children: [(0, jsx_runtime_1.jsxs)("div", { className: "flex items-center space-x-2", children: [(0, jsx_runtime_1.jsx)(lucide_react_1.AlertCircle, { className: "w-4 h-4 text-red-600" }), (0, jsx_runtime_1.jsx)("span", { className: "text-xs font-medium text-red-800", children: "S chybami" })] }), (0, jsx_runtime_1.jsx)("div", { className: "text-lg font-bold text-red-900 mt-1", children: spellCheckStats.withErrors }), (0, jsx_runtime_1.jsxs)("div", { className: "text-xs text-red-600", children: [spellCheckStats.totalErrors, " celkem chyb"] })] })] }), spellCheckStats.total > 0 && ((0, jsx_runtime_1.jsxs)("div", { className: "mt-3", children: [(0, jsx_runtime_1.jsxs)("div", { className: "flex items-center justify-between text-xs text-gray-600 mb-1", children: [(0, jsx_runtime_1.jsx)("span", { children: "Kvalita pravopisu" }), (0, jsx_runtime_1.jsxs)("span", { children: [100 - spellCheckStats.errorRate, "%"] })] }), (0, jsx_runtime_1.jsx)("div", { className: "w-full bg-gray-200 rounded-full h-2", children: (0, jsx_runtime_1.jsx)("div", { className: `h-2 rounded-full transition-all duration-300 ${spellCheckStats.errorRate <= 10 ? 'bg-green-500' :
                                        spellCheckStats.errorRate <= 25 ? 'bg-yellow-500' : 'bg-red-500'}`, style: { width: `${100 - spellCheckStats.errorRate}%` } }) })] }))] }), (0, jsx_runtime_1.jsx)("div", { className: "p-4", children: !showProgress ? ((0, jsx_runtime_1.jsx)("button", { onClick: handleSpellCheck, disabled: isRunning || segments.length === 0, className: `
              w-full flex items-center justify-center space-x-2 px-4 py-2 rounded-md text-sm font-medium
              transition-colors duration-200
              ${segments.length === 0
                        ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                        : isRunning
                            ? 'bg-blue-100 text-blue-700 cursor-not-allowed'
                            : 'bg-blue-600 hover:bg-blue-700 text-white'}
            `, children: isRunning ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(lucide_react_1.Clock, { className: "w-4 h-4 animate-spin" }), (0, jsx_runtime_1.jsx)("span", { children: "Kontroluji..." })] })) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(lucide_react_1.Play, { className: "w-4 h-4" }), (0, jsx_runtime_1.jsx)("span", { children: "Spustit kontrolu" })] })) })) : ((0, jsx_runtime_1.jsxs)("div", { className: "space-y-3", children: [(0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsxs)("div", { className: "flex items-center justify-between text-xs text-gray-600 mb-1", children: [(0, jsx_runtime_1.jsx)("span", { children: progress?.current || 'Zpracovávám...' }), (0, jsx_runtime_1.jsxs)("span", { children: [progress?.processed || 0, " / ", progress?.total || 0] })] }), (0, jsx_runtime_1.jsx)("div", { className: "w-full bg-gray-200 rounded-full h-2", children: (0, jsx_runtime_1.jsx)("div", { className: "bg-blue-500 h-2 rounded-full transition-all duration-300", style: {
                                            width: `${progress?.total ? (progress.processed / progress.total) * 100 : 0}%`
                                        } }) })] }), isRunning && ((0, jsx_runtime_1.jsx)("button", { onClick: handleCancel, className: "w-full px-4 py-2 text-sm text-gray-600 hover:text-gray-800 hover:bg-gray-100 rounded-md transition-colors", children: "Zru\u0161it" }))] })) }), spellCheckStats.total > 0 && ((0, jsx_runtime_1.jsx)("div", { className: "px-4 pb-4", children: (0, jsx_runtime_1.jsxs)("div", { className: "flex items-center space-x-2 text-xs text-gray-500", children: [(0, jsx_runtime_1.jsx)(lucide_react_1.BarChart3, { className: "w-3 h-3" }), (0, jsx_runtime_1.jsxs)("span", { children: ["Posledn\u00ED kontrola: ", spellCheckStats.withErrors, " chyb v ", spellCheckStats.total, " segmentech"] })] }) }))] }));
};
exports.default = SpellCheckPanel;
